import React from 'react';
import Select from 'react-select';
import axios from 'axios';
import { connect } from 'react-redux';
import { kinetik_api_url } from '../utilities/const';
import { companyProfileSettings } from '../actions/settings_companyProfile.action';
import PropTypes from 'prop-types';


class SelectPayers extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            data: [
                {label: 'Data is loading..', value: ''}
            ],
            isDataUpdated: false,
            gotPayers: false
        };
    }
    componentDidMount(){
        let URL = kinetik_api_url + '/payerlist/payers';

        axios.get(URL)
        .then( (result) => {
            let filteredData = result.data.data.map( (v, k) => {
                return { label: v.payer_name, value: v.payer_id}
            });
            this.setState({
                isDataUpdated: true,
                data: filteredData
            });
        });

    }

    deleteSelection = (selected) => {
        
        let newPayers = this.props.payersList.filter( v => v.value !== selected);
        this.props.onSelectPayers(newPayers);

        this.props.companyProfileSettings({
            company_payers: newPayers
        });

    }

    componentDidUpdate(){
        if(this.props.payersList.length !== 0 && !this.state.gotPayers){
            this.setState({
                gotPayers: true
            })
        }
    }

    render(){
        return (
            <div className="brd_tab_cntnt vendor__">
                <h4 className="vendor_h_title">Payers</h4>
                <div className="brding_frm_ele fix_payers_margin">
                    

                    {
                        this.state.gotPayers && (
                            <Select
                                closeMenuOnSelect={true}
                                isMulti
                                options={this.state.data}
                                className="payers_menu___cls select_payers_cls"
                                onChange={(val) => this.props.onSelectPayers(val)}
                                defaultValue={this.props.payersList}
                            />
                        )
                    }
                </div> <br />
            </div>
        )
    }
};

SelectPayers.propTypes = {
    companyProfileSettings: PropTypes.func.isRequired,
    onSelectPayers: PropTypes.func.isRequired,
    selectedPayers: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    payersList: state.settingsData.company_payers
    
});

export default connect(mapStateToProps, { companyProfileSettings })(SelectPayers);


// WEBPACK FOOTER //
// ./src/app/profile_settings/SelectPayers.js